module.exports = __webpack_public_path__ + "img/cartaz.a9562ebf.jpg";